import { POST_RELATE_ICONS } from './RelateIcon.constants';
import { RelateIconProps } from './RelateIcon.interfaces';

export const RelateIcon = ({ relateType }: RelateIconProps) => {
  const Icon = POST_RELATE_ICONS[relateType];
  return <Icon />;
};
